import { render, staticRenderFns } from "./PersonalVinculadoConvocatoriaDialogComponent.vue?vue&type=template&id=7ed2bdf4"
import script from "./PersonalVinculadoConvocatoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./PersonalVinculadoConvocatoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports